export const key = "kyc.start";
